var map = {
	"./10percent-hq.png": 60264,
	"./13aotopo-cena-chegada.png": 73420,
	"./13aotopo-hq.png": 50452,
	"./20minutos-hq.png": 36212,
	"./48km-cena-jadedelicada.png": 58192,
	"./48km-hq.png": 5272,
	"./48km-onom-peidin.png": 31636,
	"./48km-shipp-kellyejade.png": 88736,
	"./4leafclover-hq.png": 34996,
	"./60km-hq.png": 23320,
	"./6reasons-hq.png": 71524,
	"./Proximas leituras.png": 71196,
	"./Screenshot_1.png": 78372,
	"./aalmagemeadoanjo-hq.png": 5972,
	"./abadday-exp-queazar.png": 96948,
	"./abadday-hq.png": 47468,
	"./abolhadesol-hq.png": 31884,
	"./abordodobeagle-hq.png": 79820,
	"./abutre-hq.png": 29676,
	"./acasadospecados-hq.png": 74912,
	"./acoordenada-cenas-encaradanataberna.png": 50512,
	"./acoordenada-exp-antonieta.png": 17244,
	"./acoordenada-hq.png": 30364,
	"./acoordenada-onomatopeita-pocotopng.png": 37048,
	"./acquine-hq.png": 44408,
	"./acquine-shipp-niccoeshun.png": 29932,
	"./ada-hq.png": 21680,
	"./ada-masc-fantasma.png": 68716,
	"./ada-multi-quadrinhosa2.png": 50036,
	"./adoravel-hq.png": 80228,
	"./adoutoraealoba-hq.png": 61448,
	"./aengenheiradoamor-hq.png": 50056,
	"./aesperademisun-hq.png": 39460,
	"./afeto-hq.png": 20032,
	"./agatha-hq.png": 63628,
	"./ageofguardian-golpe-explosivepunch.png": 90404,
	"./ageofguardian-hq.png": 15068,
	"./agerstellas-exp-lina.png": 46496,
	"./agerstellas-golp-lobaodechoque.png": 45112,
	"./agerstellas-hq.png": 62072,
	"./agerstellas-masc-fulpus.png": 55948,
	"./agrandegrug-artef-aneldedolperganger.png": 29168,
	"./agrandegrug-char-grug.png": 90837,
	"./agrandegrug-hq.png": 89608,
	"./ahistoriadepiabinha-hq.png": 86436,
	"./ahistoriadepiabinha-masc-piabinha.png": 60744,
	"./ainsurgenciaceleste-artef-chaveslimiares.png": 82680,
	"./ainsurgenciaceleste-exp-camisa0.png": 3276,
	"./ainsurgenciaceleste-exp-kaiemchoq.png": 25876,
	"./ainsurgenciaceleste-hq.png": 27701,
	"./ainsurgenciaceleste-lugar-planocelestial.png": 5776,
	"./ajornadadeari-hq.png": 43860,
	"./albi-hq.png": 27124,
	"./alcateia-hq.png": 2968,
	"./alemdalua-hq.png": 65472,
	"./alendadedarkenmallus-hq.png": 14132,
	"./alendadedipp-hq.png": 18696,
	"./algaia-golpe-aiven.png": 55060,
	"./algaia-hq.png": 43240,
	"./algaia-multi-lendasdeveracruz.png": 39653,
	"./algaia-onom-kaplau.png": 13424,
	"./alice-hq.png": 39860,
	"./alice-ships-aliceekaio.png": 784,
	"./aliceanimo-artef-espadao.png": 19915,
	"./aliceanimo-exp-alice.png": 15040,
	"./aliceanimo-exp-eh.png": 78832,
	"./aliceanimo-exp-serio.png": 79392,
	"./aliceanimo-hq.png": 14260,
	"./aliceanimoserie-hq.png": 96684,
	"./amalgama-cenas-boitatamapinguari.png": 18252,
	"./amalgama-hq.png": 89092,
	"./amaterasu-hq.png": 5708,
	"./ameaçaalien-hq.png": 96,
	"./amigascolegiais-hq.png": 69856,
	"./amodestrebellion-hq.png": 17076,
	"./amon-artef-aneldefogo.png": 49932,
	"./amon-capa.png": 64968,
	"./amon-cena-amon.png": 41078,
	"./amon-hq.png": 33728,
	"./amoralemdotempo-hq.png": 12308,
	"./amunatan-hq.png": 47220,
	"./analizaforçadoamor-hq.png": 90956,
	"./animus-char-almaemchoque.png": 2904,
	"./animus-hq.png": 66540,
	"./animus-lugares-templo.png": 95404,
	"./anjodaguarda-hq.png": 30288,
	"./anjosedemonios-hq.png": 40100,
	"./anjosedemonios2-hq.png": 36188,
	"./anneebrianna-hq.png": 83892,
	"./aordem-hq.png": 80316,
	"./aordem-multi-soberania.png": 96344,
	"./aordemdeavalon-hq.png": 56956,
	"./aorigemdosdeuses-hq.png": 85060,
	"./apenasumpedro-hq.png": 33237,
	"./apervertidaeovirtuoso-cenas-bloqueio.png": 14244,
	"./apervertidaeovirtuoso-hq.png": 66736,
	"./apoly-hq.png": 1335,
	"./appleparadise-golp-shadowslaves.png": 66608,
	"./appleparadise-hq.png": 81864,
	"./aprofeciaprofunda-golp-mijadaastral.png": 31848,
	"./aprofeciaprofunda-hq.png": 65248,
	"./aquan-hq.png": 66492,
	"./aquelamalditalunatica-hq.png": 36096,
	"./aquelapequenaedocefadamortiferaemnossocaminho-golp-deathslice.png": 84876,
	"./aquelapequenaedocefadamortiferaemnossocaminho-hq.png": 13340,
	"./aquelapequenaedocefadamortiferaemnossocaminho-masc-fayro.png": 98604,
	"./aretomada-cena-golpedeestado.png": 20912,
	"./aretomada-hq.png": 43136,
	"./aretomada-onom-vapo.png": 74636,
	"./arinopaisdasmascaras-char-gemini.png": 45367,
	"./arinopaisdasmascaras-hq.png": 1604,
	"./arlindo-hq.png": 72636,
	"./arlindo-lugar-saidadaescolinha.png": 20192,
	"./arroz-hq.png": 5292,
	"./arthureosol-artef-guardachuva.png": 87904,
	"./arthureosol-capa-5.png": 55772,
	"./arthureosol-cena-eunaoqueroficarsozinhodenovo.png": 80240,
	"./arthureosol-cena-lottos.png": 43624,
	"./arthureosol-exp-arthuraura.png": 10252,
	"./arthureosol-exp-marisesegurando.png": 94812,
	"./arthureosol-golpe-crimsonwave-png.png": 8380,
	"./arthureosol-golpe-goldensun.png": 4895,
	"./arthureosol-hq.png": 65236,
	"./aruadecima-hq.png": 74204,
	"./asaventurasdogaoalbi-hq.png": 93112,
	"./asentregasdejunior-hq.png": 18220,
	"./asentregasdejunior-masc-pitoquinha.png": 51432,
	"./askingyou-hq.png": 56780,
	"./asperipeciasdegabi-exp-gabi.png": 74624,
	"./asperipeciasdegabi-hq.png": 87708,
	"./asperipeciasdegabi-onom-tôimpng.png": 36731,
	"./assombração-exp-help.png": 19384,
	"./assombração-hq.png": 40216,
	"./atinypromiseinaneverendingday-cena-heroinacional.png": 74304,
	"./atinypromiseinaneverendingday-hq.png": 79376,
	"./atofalho-hq.png": 48860,
	"./atriplicedeumolho-hq.png": 44604,
	"./aturacaimura-hq.png": 6468,
	"./avareza-hq.png": 28840,
	"./aventurasfolcloricas-hq.png": 92556,
	"./axiomavetiti-hq.png": 31900,
	"./azurasheart-hq.png": 97408,
	"./bacecemena-cenas-batalhadagravida.png": 72140,
	"./bacecemena-exp-grávida.png": 68052,
	"./bacecemena-hq.png": 57368,
	"./balsamus-char-jeje.png": 43268,
	"./balsamus-hq.png": 44552,
	"./basket360-exp-quem.png": 62224,
	"./basket360-exp-sonin.png": 93620,
	"./basket360-hq.png": 24644,
	"./bear-hq.png": 96796,
	"./belialscontract-hq.png": 83864,
	"./bemdoseulado-hq.png": 38080,
	"./bilove-hq.png": 44524,
	"./bilove-masc-oscar.png": 98340,
	"./bittersweet-hq.png": 53456,
	"./blackeneddays-hq.png": 32040,
	"./bloodgriffin-hq.png": 43452,
	"./bloodring-hq.png": 45828,
	"./bluemoon-cenas-basil.png": 85204,
	"./bluemoon-hq.png": 34288,
	"./boitataespacial-cenas-boitata.png": 70216,
	"./boitataespacial-char-capitaamana.png": 77996,
	"./boitataespacial-hq.png": 52096,
	"./bomdiaestrelinha-hq.png": 20280,
	"./boteco-hq.png": 25548,
	"./botequeiros-hq.png": 65516,
	"./brainrootmirage-cenas-sos.png": 84207,
	"./brainrootmirage-hq.png": 91372,
	"./brakuman-cena-animebrothers.png": 64748,
	"./brakuman-cena-motivacao.png": 54876,
	"./brakuman-cena-quadrinista.png": 63236,
	"./brakuman-hq.png": 7880,
	"./breakthecycle-hq.png": 4008,
	"./brisaerrada-cenas-catuaba.png": 84912,
	"./brisaerrada-hq.png": 66172,
	"./brokenangelsarah-hq.png": 42632,
	"./brokenangeltheory-hq.png": 78301,
	"./brunotemumnamorado-hq.png": 99296,
	"./byebyebunny-hq.png": 39972,
	"./cafeina-exp-vounada.png": 90224,
	"./cafeina-hq.png": 60764,
	"./calendar-exp-suzan.png": 47212,
	"./calendar-hq.png": 37160,
	"./calista-golp-abraçodassombras.png": 856,
	"./calista-golp-estacasdegelo.png": 94060,
	"./calistia-capa-2.png": 5316,
	"./calistia-hq.png": 42612,
	"./camucamu-hq.png": 12040,
	"./camucamu-ono-brasil.png": 69224,
	"./cancaodonarval-hq.png": 66176,
	"./caramelorex-capa.png": 76852,
	"./caramelorex-cena-bomgaroto.png": 54264,
	"./caramelorex-golp-garrasembrasadas.png": 33716,
	"./caramelorex-golp-supernovacaramelo.png": 74344,
	"./caramelorex-hq.png": 85472,
	"./caramelorex-lugar-monteroraima.png": 22519,
	"./caramelorex-mascotes-rex.png": 66756,
	"./carol-hq.png": 82384,
	"./carolbabel-hq.png": 65856,
	"./cavaleirosdeferro-hq.png": 55768,
	"./caveston-hq.png": 42855,
	"./cavetown-hq.png": 8748,
	"./cellatrix-hq.png": 79764,
	"./cennetaespadarubra-capa.png": 61760,
	"./cennetaespadarubra-char-aylla.png": 50476,
	"./cennetaespadarubra-exp-moça.png": 86284,
	"./cennetaespadarubra-exp-ooh.png": 45984,
	"./cennetaespadarubra-golp-ignis.png": 9608,
	"./cennetaespadarubra-golp-parumflammae.png": 1596,
	"./cennetaespadarubra-hq.png": 20168,
	"./chapolinxalmanegra-hq.png": 62100,
	"./chronosandray-hq.png": 47844,
	"./cidadedesucata-hq.png": 15876,
	"./cinza-hq.png": 44288,
	"./cinza-shipp-arrozefeijao.png": 69208,
	"./circodelata-hq.png": 61591,
	"./cococontos-hq.png": 24008,
	"./coisasdealuno-hq.png": 22364,
	"./colatino-capa.png": 89488,
	"./colatino-char-carranca.png": 80151,
	"./colatino-hq.png": 57824,
	"./colatino-ono-chablau.png": 5528,
	"./colibris-hq.png": 77956,
	"./comeasyouare-hq.png": 15912,
	"./comoeurealmente-hq.png": 29052,
	"./comofazeramigoseenfrentarfantasmas-hq.png": 6648,
	"./comosetornarhumano-capa3.png": 65540,
	"./comosetornarhumano-cenas-amormundano.png": 29564,
	"./comosetornarhumano-char-nonóia.png": 23492,
	"./comosetornarhumano-char-unknow.png": 66204,
	"./comosetornarhumano-hq.png": 32524,
	"./comosetornarhumano-lugar-tribunaldasalmas.png": 28911,
	"./comosetornarhumano-masc-lobinhoespectral.png": 94680,
	"./comvoce-hq.png": 31960,
	"./comvoce-ship-tanemishino.png": 83204,
	"./conseguemeentender-hq.png": 31535,
	"./contosdecinderella-hq.png": 35864,
	"./contosdoespelho-hq.png": 10684,
	"./contosdosamuraidamontanha-cenas-oultimodesafio.png": 49036,
	"./contosdosamuraidamontanha-char-mestreshin.png": 68588,
	"./contosdosamuraidamontanha-hq.png": 10792,
	"./contosdosamuraidamontanha-lugar-dojo.png": 49336,
	"./contosmacabrosdotumulododemonio-exp-medo.png": 60076,
	"./contosmacabrosdotumulododemonio-hq.png": 20676,
	"./cordãomistico-arted-cordaomistico.png": 30252,
	"./cordãomistico-hq.png": 23980,
	"./cordãomistico-lugar-florestasagrada.png": 96340,
	"./cores-hq.png": 98608,
	"./cortinarasgada-hq.png": 94260,
	"./cosmicguardian-hq.png": 75580,
	"./cosmico-hq.png": 43560,
	"./cowgirlspunches.png": 51424,
	"./cramunho-hq.png": 56440,
	"./cronicasdamoon-hq.png": 72320,
	"./crr-hq.png": 57860,
	"./cupid-hq.png": 68663,
	"./curseconquest-hq.png": 15823,
	"./cursedwolf-hq.png": 65156,
	"./dahlia-hq.png": 50692,
	"./damafatal-hq.png": 73024,
	"./dandara-hq.png": 91584,
	"./darkbloodhound.png": 7620,
	"./darkrose-hq.png": 33856,
	"./darksshotgunner-hq.png": 59556,
	"./daydreampeak-hq.png": 39584,
	"./daydreampeak-lugar-mundodossonhos.png": 59432,
	"./daydreampeak-masc-jade.png": 60428,
	"./debiloids-hq.png": 86672,
	"./decisoes-hq.png": 15328,
	"./deltaparadise-hq.png": 82784,
	"./demonhunters-hq.png": 20244,
	"./demonkeeper-hq.png": 46744,
	"./demonsonearth-cenas-anjocalvo.png": 41492,
	"./demonsonearth-hq.png": 94076,
	"./deoutrosmundos-hq.png": 27712,
	"./deoutrosmundos-ship-ametistaeapolo.png": 53568,
	"./derepenteshoujo-hq.png": 70448,
	"./desculpaeugostodevc-cenas-euamooyuri.png": 87976,
	"./desculpaeugostodevc-exp-riedanada.png": 39239,
	"./desculpaeugostodevc-exp-veia.png": 50944,
	"./desculpaeugostodevc-hq.png": 99240,
	"./desejosvampiricos-hq.png": 24181,
	"./despaisknowsnobetter-hq.png": 54028,
	"./desviantes-cena-cristo.png": 45800,
	"./desviantes-hq.png": 4760,
	"./desviantes-lugar-riodejaneiroapocalipticopng.png": 12252,
	"./deusdachuva-hq.png": 75788,
	"./diadeprova.png": 77000,
	"./diadesaovalentim-hq.png": 72404,
	"./diariodemonstros-hq.png": 54616,
	"./diascinzentos-artef-espada.png": 90716,
	"./diascinzentos-cenas-chegadadoheroi.png": 20292,
	"./diascinzentos-cenas-socofraco.png": 39560,
	"./diascinzentos-hq.png": 68640,
	"./diascinzentos-lugares-ilhascelestes.png": 32952,
	"./diascinzentos-mult-silva.png": 98516,
	"./digude-hq.png": 88124,
	"./dimensionalsaviors-hq.png": 64216,
	"./docelegado-artef-tacodedialogo.png": 49988,
	"./docelegado-hq.png": 20136,
	"./doiscorpos-hq.png": 27304,
	"./doraeagata-hq.png": 64272,
	"./doraeagata-masc-agata.png": 33936,
	"./doutora-hq.png": 68944,
	"./draculaquerumnamorado-exp-choro.png": 55496,
	"./draculaquerumnamorado-hq.png": 58572,
	"./dragoncity-cena-vaidartudocerto.png": 79724,
	"./dragoncity-hq.png": 93120,
	"./dreams-hq.png": 72908,
	"./dungeoncrawler-hq.png": 91000,
	"./dyinglight-hq.png": 76568,
	"./eclipse-hq.png": 62428,
	"./edificio-hq.png": 64768,
	"./elementalkings-capa.png": 61268,
	"./elementalkings-hq.png": 32876,
	"./elementalkingsfirehearts-hq.png": 48392,
	"./embaraçada-char-prot.png": 31920,
	"./embaraçada-hq.png": 4535,
	"./embuscadescientia-hq.png": 54900,
	"./emocoes-artef-joia.png": 26868,
	"./emocoes-hq.png": 82824,
	"./empregodeverao-hq.png": 68092,
	"./enquantoanevecai-hq.png": 59444,
	"./entredoismundos-hq.png": 85752,
	"./errosdegravaçao-hq.png": 55276,
	"./eruve-hq.png": 92224,
	"./escarrabrasa-cena-escarrafuria.png": 51772,
	"./escarrabrasa-cena-redfury.png": 60808,
	"./escarrabrasa-hq.png": 55464,
	"./escritoriodospassaros-hq.png": 1084,
	"./espadachinsderua-hq.png": 14452,
	"./esquadraocoraçãocadente-hq.png": 87232,
	"./etapoarr-hq.png": 67392,
	"./etheryum-hq.png": 88528,
	"./eunaotoafimdomocinho-exp-cascandoobico.png": 10128,
	"./eunaotoafimdomocinho-hq.png": 74068,
	"./euodeiocereaischocosugar-hq.png": 35628,
	"./eusoqueroumcopodeleite.png": 77199,
	"./everydaylifeatbrightrosebushhighschool-exp-alysson.png": 63108,
	"./everydaylifeatbrightrosebushhighschool-hq.png": 46200,
	"./faculdadedemangaka-hq.png": 80348,
	"./fantasyland-hq.png": 92853,
	"./fatalabruxadebeliverde-capa.png": 95236,
	"./fatalabruxadebeliverde-cena-autor.png": 69548,
	"./fatalabruxadebeliverde-cenas-asurradabruxa.png": 46024,
	"./fatalabruxadebeliverde-exp-beicinho.png": 47340,
	"./fatalabruxadebeliverde-hq.png": 42356,
	"./fatalabruxadebeliverde-onom-blou.png": 45320,
	"./fathersgift-hq.png": 2068,
	"./filhosdafenix-hq.png": 61824,
	"./finalspark-hq.png": 83720,
	"./findarosa-hq.png": 96772,
	"./firula-hq.png": 41544,
	"./fishermantales-hq.png": 5912,
	"./flap-hq.png": 5565,
	"./flife-hq.png": 18884,
	"./florence-hq.png": 53452,
	"./florescer-hq.png": 91472,
	"./florescer-shipp-jacienaia.png": 34960,
	"./florestadosespiritos-hq.png": 47172,
	"./flowerfield-hq.png": 17300,
	"./flyhighshiny-hq.png": 36164,
	"./fogosdeoficio-hq.png": 30164,
	"./folklorewarriors98-char-vitoriaregia.png": 97516,
	"./folklorewarriors98-hq.png": 69244,
	"./folklorewarriors98-onom-pimba.png": 40628,
	"./foradesi-hq.png": 64556,
	"./forgetmenot-hq.png": 84704,
	"./formaouconsciencia-cena-eusoucomovoce.png": 96060,
	"./formaouconsciencia-cena-pactododragão.png": 99696,
	"./formaouconsciencia-exp-kensu.png": 63052,
	"./formaouconsciencia-hq.png": 35101,
	"./fraternidades-hq.png": 80972,
	"./fraternidades-lugares-guarujá.png": 28484,
	"./frogboy-hq.png": 38404,
	"./fé-hq.png": 50480,
	"./garotasfofas-hq.png": 53736,
	"./garotatoupeira-char-molly.png": 90368,
	"./garotatoupeira-hq.png": 40300,
	"./garotatoupeira-lugar-rj.png": 37844,
	"./gatho-hq.png": 5248,
	"./gatho-lugar-cazaltar.png": 58872,
	"./gato-hq.png": 35376,
	"./gibideamor-hq.png": 78983,
	"./gibideamor-lugar-institutoguarulhos.png": 74764,
	"./gibideamor-onom-sinaaaaal.png": 77532,
	"./gigantesdeoutromundo-hq.png": 10092,
	"./ginga-cena-paranaue.png": 9748,
	"./ginga-golpe-chute.png": 92064,
	"./ginga-hq.png": 55456,
	"./ginga-lugar-bahia.png": 47060,
	"./ginga-multi-aquelapequenaedocefada.png": 96876,
	"./ginga-multi-estudioarmon.png": 17564,
	"./ginga-multi-syncro.png": 57056,
	"./ginga-multi-valón.png": 51064,
	"./ginga-ono-plaft.png": 11792,
	"./ginga-seriehq.png": 64976,
	"./girt-hq.png": 33720,
	"./gogogofelicity-hq.png": 42712,
	"./goroseries-hq.png": 47768,
	"./gotohell-hq.png": 85604,
	"./grandmasflavor-hq.png": 85552,
	"./grughappydays-hq.png": 51821,
	"./guiinchaconspiração-hq.png": 14404,
	"./guiltyheartofabsoluteevil-artef-cintoestelar.png": 37591,
	"./guiltyheartofabsoluteevil-char-xerifepretagoista.png": 40084,
	"./guiltyheartofabsoluteevil-hq.png": 6836,
	"./haruka-hq.png": 18320,
	"./heartofthetruefriend-hq.png": 24808,
	"./helldeck-dean.png": 11464,
	"./helldeck-hq.png": 60940,
	"./hellssurfer-hq.png": 19172,
	"./hex-hq.png": 39416,
	"./hidingplace-hq.png": 76260,
	"./historiacurtaemtrespaginas-char-isabela.png": 88324,
	"./historiacurtaemtrespaginas-hq.png": 60820,
	"./homemgrilo-hq.png": 45636,
	"./hooligan-hq.png": 9028,
	"./hqdebriga-hq.png": 62924,
	"./hqdebriga-lugar-bronx.png": 66056,
	"./hqdebriga-ono-blou.png": 90072,
	"./hqsde3paginas-hq.png": 78852,
	"./humanitystaste-hq.png": 49751,
	"./humanossonhamcomrelacionamentoseletricos-hq.png": 89720,
	"./ikari-hq.png": 24300,
	"./illusion-hq.png": 91020,
	"./iloveyou-hq.png": 51092,
	"./iludidos-hq.png": 26024,
	"./impiedoso-capa.png": 77928,
	"./impiedoso-hq.png": 11256,
	"./impiedoso-masc-ursinho.png": 78024,
	"./inbetween-hq.png": 42688,
	"./iniciação-hq.png": 45668,
	"./inospito-hq.png": 91196,
	"./insanecrow-artef-craniodecorno.png": 80552,
	"./insanecrow-hq.png": 67196,
	"./insanecrow-lugar-entquerido.png": 69312,
	"./insanecrow-lugar-lacasadocaralho.png": 26760,
	"./insanecrow-masc-nyu.png": 2048,
	"./inspiração-cena-acorda.png": 7900,
	"./inspiração-hq.png": 21756,
	"./intothesky-hq.png": 8600,
	"./inundação-hq.png": 628,
	"./inusitado-hq.png": 8976,
	"./inusitado-shipp-jaqueedaniel.png": 53212,
	"./invisible-hq.png": 18448,
	"./irauna-artef-facasobrenatural.png": 67664,
	"./irauna-cena-irene.png": 19128,
	"./irauna-char-irene.png": 16216,
	"./irauna-hq.png": 43552,
	"./irauna-lugar-rockao.png": 60192,
	"./irauna-masc-doguinhospng.png": 3176,
	"./irauna-shipp-nandaeirene.png": 64616,
	"./irmaoscarranca-cenas-ataquedacobra.png": 16592,
	"./irmaoscarranca-char-irmaos.png": 96164,
	"./irmaoscarranca-hq.png": 57072,
	"./ironlady-hq.png": 19112,
	"./ironlady-ono-ratata.png": 51204,
	"./istella-cenas-continua.png": 68816,
	"./istella-char-istella.png": 45719,
	"./istella-exp-ameaça.png": 91388,
	"./istella-exp-risonha.png": 19328,
	"./istella-hq.png": 64320,
	"./istella-multi-dinossauromaru.png": 55780,
	"./istella-multi-reidelata.png": 78680,
	"./iwannabegod-capa.png": 67792,
	"./iwannabegod-hq.png": 69344,
	"./iwannabesatan-golp-rumbletcheco.png": 47533,
	"./iwannabesatan-golp-tchecopow.png": 86428,
	"./iwannabesatan-hq.png": 33428,
	"./iwannabesatan-lugar-stworld.png": 11824,
	"./iwannabesatan-multi-superfightingheroes.png": 34772,
	"./iwannabesatan-onon-tcheco.png": 49976,
	"./jefejeb-hq.png": 72955,
	"./jerimum-hq.png": 82372,
	"./jerimum-lugar-casadocao.png": 40544,
	"./jerimun-char-jerimum.png": 14864,
	"./jerimun-exp-hein.png": 49520,
	"./joesangar-hq.png": 18916,
	"./jonasoquasemago-exp-jonas.png": 93248,
	"./jonasoquasemago-hq.png": 34204,
	"./jonasoquasemago-mascote-coelho.png": 13940,
	"./jorgeeclyde-hq.png": 19152,
	"./jucistar-hq.png": 7332,
	"./jucistar-lugar-jucistar.png": 42087,
	"./junhonaoéjuno-capa-2.png": 58871,
	"./junhonaoéjuno-exp-seentregou.png": 34476,
	"./junhonaoéjuno-hq.png": 58728,
	"./junhonaoéjuno-masc-freduardo.png": 48784,
	"./junhonaoéjuno-ship-danielejuno.png": 20540,
	"./juquinha-cena-viagemaofundodoego.png": 1368,
	"./juquinha-hq.png": 688,
	"./juquinha-multi-toolschallenge.png": 36192,
	"./justaminute-hq.png": 99896,
	"./justkeepdrawing-cena-brigaautor.png": 11772,
	"./justkeepdrawing-hq.png": 96549,
	"./kairuede-hq.png": 4684,
	"./kairuede-lugar-soteropolis.png": 17988,
	"./karina-hq.png": 68636,
	"./kellyyoungcreepy-hq.png": 9740,
	"./kellyyoungshifty-char-kelly.png": 78036,
	"./kellyyoungshifty-hq.png": 13432,
	"./kellyyoungspooky-hq.png": 59564,
	"./kellyyoungspooky-multi-jornadadeari.png": 57312,
	"./kennylendasdeforya-hq.png": 12148,
	"./kikronicles-exp-hein.png": 83860,
	"./kikronicles-hq.png": 33560,
	"./kingspath-hq.png": 56720,
	"./krestgale-exp-confia.png": 22256,
	"./krestgale-hq.png": 68760,
	"./krestgale-onom-bbbuuaaa.png": 64048,
	"./krista-hq.png": 12156,
	"./kstar-cena-gostosadomal.png": 5268,
	"./kstar-char-princesaplatina.png": 10853,
	"./kstar-hq.png": 1520,
	"./kungfu-hq.png": 54012,
	"./kungfu-ship-amadas.png": 92316,
	"./kurtcontained-hq.png": 77212,
	"./kyleeemkabusmo-hq.png": 7276,
	"./lampiao-hq.png": 23144,
	"./lampiao-shipp-lampiaoemaria.png": 99484,
	"./larvas-hq-2finados.png": 43744,
	"./larvas-hq.png": 48880,
	"./laçosproibidos-hq.png": 68412,
	"./lebreecoelho-golpe-gomugomu.png": 6104,
	"./lebreecoelho-hq.png": 79348,
	"./lebreecoelho-ship-lebreecoelho.png": 60560,
	"./lebreecoelho-ship-leonejimmy.png": 76976,
	"./legiaosa-hq.png": 59172,
	"./leitederramado-hq.png": 77644,
	"./lendahand-hq.png": 76528,
	"./lendasamazonicas-capa.png": 4724,
	"./lendasamazonicas-hq.png": 6348,
	"./lendasdeveracruz-artef-armatemplaria.png": 60908,
	"./lendasdeveracruz-golpe-cortecelestial.png": 2012,
	"./lendasdeveracruz-hq.png": 35580,
	"./lendasdeveracruz-lugar-saofranciscopng.png": 332,
	"./lendasdeveracruz-onom-currupio.png": 90308,
	"./liliandgrave-hq.png": 87484,
	"./liliandgrave-masc-morgan.png": 33776,
	"./lily-chat-lily.png": 94308,
	"./lily-hq.png": 34328,
	"./lilyslove-hq.png": 70173,
	"./livingthemoment-hq.png": 50244,
	"./livrosepiercings-hq.png": 51972,
	"./lobomau-capa-6.png": 28408,
	"./lobomau-char-lobomau.png": 69752,
	"./lobomau-hq.png": 77964,
	"./lockedoutofhell-exp-dumb.png": 40652,
	"./lockedoutofhell-hq.png": 73620,
	"./lostlilled-hq.png": 63784,
	"./lotusdesangue-hq.png": 64055,
	"./lourrence-hq.png": 8061,
	"./loveorfriendship.png": 56580,
	"./lovewars-hq.png": 88860,
	"./lynneogatocarteiro-hq.png": 42708,
	"./lynneogatocarteiro-masc-erik.png": 50620,
	"./macacadas-hq.png": 32348,
	"./macacadas-mult-contosdosamurai.png": 99824,
	"./madoushizero-hq.png": 17072,
	"./madreluna-char-madreluna.png": 1660,
	"./madreluna-hq.png": 97144,
	"./mafiadrip-artef-familie.png": 71080,
	"./mafiadrip-cenas-jeanpeladaopng.png": 27921,
	"./mafiadrip-char-leather.png": 13188,
	"./mafiadrip-char-marcelo.png": 30120,
	"./mafiadrip-exp-jean.png": 63968,
	"./mafiadrip-hq.png": 30452,
	"./magh-arted-espelhoroxo.png": 91340,
	"./magh-artef-luvadeinvocador.png": 17956,
	"./magh-capas-3.png": 59652,
	"./magh-capas.png": 98480,
	"./magh-cenas-universo.png": 37504,
	"./magh-cenas.png": 13576,
	"./magh-char-rainhahel.png": 30420,
	"./magh-hq.png": 25888,
	"./magh-multi-horrortales.png": 30296,
	"./magiccrusaders-hq.png": 81212,
	"./maiado-hq.png": 31796,
	"./maldição-hq.png": 75072,
	"./mamaocomaçucar-hq.png": 14672,
	"./mamaocomaçucar-lugar-paogourmetizado.png": 58540,
	"./mamaocomaçucar-mult-48km.png": 19176,
	"./mamaocomaçucar-shipp-lucasenatan.png": 29453,
	"./manakaru-hq.png": 49004,
	"./manakaru-lugar-hellcife.png": 22032,
	"./manualpraticodagarotamagica-hq.png": 52628,
	"./manualpraticodagarotamagica-masc-blaze.png": 77388,
	"./marblecreatures-hq.png": 88495,
	"./matamata-hq.png": 56548,
	"./matandoaula-hq.png": 85332,
	"./matandoaula-ship-bastion.png": 17488,
	"./meamecomoseeuestivessemorta-hq.png": 40128,
	"./medalhadark-hq.png": 15168,
	"./mediunidade-hq.png": 70176,
	"./mellohi-hq.png": 55472,
	"./mellohi-mult-lqn.png": 31908,
	"./memoriasagridoces-hq.png": 62248,
	"./memoriasagridoces-ship-sophieedamian.png": 29776,
	"./memórias-hq.png": 27884,
	"./memóriasdesangue-hq.png": 66912,
	"./menmar-hq.png": 47492,
	"./mentefisgada-hq.png": 22124,
	"./metagemma-hq.png": 33484,
	"./metalmancer-capa.png": 19160,
	"./metalmancer-char-vitória.png": 86876,
	"./metalmancer-hq.png": 43816,
	"./metrowarriors-hq.png": 50696,
	"./meuamigogelado-cenas-inverno.png": 93504,
	"./meuamigogelado-hq.png": 72892,
	"./meyrin-hq.png": 2244,
	"./mfight-hq.png": 85157,
	"./microcosmus-hq.png": 77376,
	"./mindcollegium-hq.png": 35164,
	"./minhacompanheiradiaba-hq.png": 70616,
	"./miracledog-hq.png": 90288,
	"./miracledog-masc-doguinhomilagroso.png": 78228,
	"./missfortune-char-morte.png": 22696,
	"./missfortune-hq.png": 29176,
	"./misunderstood.png": 19352,
	"./mondolis-artef-espada.png": 86376,
	"./mondolis-cenas-nills.png": 21548,
	"./mondolis-hq.png": 4004,
	"./mondolis-lugar-sylseeq.png": 3748,
	"./monsterodyssey-artef-apresaancestralpng.png": 31148,
	"./monsterodyssey-cena-abertura.png": 93024,
	"./monsterodyssey-char-rockyrooster.png": 49324,
	"./monsterodyssey-exp-pedragalo.png": 49479,
	"./monsterodyssey-golpe-coconutsmash.png": 36880,
	"./monsterodyssey-golpe-goblinsmash.png": 90568,
	"./monsterodyssey-golpe-stoneshield.png": 63256,
	"./monsterodyssey-hq.png": 4754,
	"./monsterodyssey-lugar-ilhacaveirinha.png": 70456,
	"./monstersoul-hq.png": 9292,
	"./monstro-hq.png": 81980,
	"./mortalia-char-mortalia.png": 15868,
	"./mortalia-hq.png": 19820,
	"./mortisweb-hq.png": 74084,
	"./mundosemanjos-hq.png": 97637,
	"./mycrazyfriend-hq.png": 99444,
	"./naganoken-hq.png": 98100,
	"./naganoken-ono-splurt.png": 57880,
	"./naoidentificado-lugar-discovoador.png": 49040,
	"./naoidentificados-hq.png": 25368,
	"./nativopower-hq.png": 84192,
	"./neevena-hq.png": 87760,
	"./neitherbrightnordark-hq.png": 77816,
	"./netosdearquibalda-hq.png": 67616,
	"./neverlate-cena-nuncaétarde-png.png": 68656,
	"./neverlate-hq.png": 95228,
	"./neverlate-lugar-restaurante.png": 26512,
	"./nevoaescarlate-hq.png": 39500,
	"./newgame+-capa.png": 10480,
	"./newgame+-cena-npc.png": 28208,
	"./newgame+-exp-npc.png": 37024,
	"./newgame+-hq.png": 11896,
	"./newgame+-ship-npceheroi.png": 14484,
	"./nicolaseoespiritonatalino-hq.png": 99260,
	"./nimbus-capa.png": 13752,
	"./nimbus-hq.png": 41116,
	"./ninaetomas-hq.png": 86551,
	"./ninjaaascençãodosamurai-hq.png": 18160,
	"./noah-hq.png": 99220,
	"./nobicodurubu-artef-necronomicon.png": 84748,
	"./nobicodurubu-golpe-desconstrução.png": 34248,
	"./nobicodurubu-hq.png": 61912,
	"./nobicodurubu-lugar-horizontefragmentado.png": 48997,
	"./noeleamagnificafabricadebrinquedos-artef-joiadaonipresença.png": 77716,
	"./noeleamagnificafabricadebrinquedos-hq.png": 42184,
	"./nomundodealrti-hq.png": 66072,
	"./nospaceforus-hq.png": 55544,
	"./notaemsangue-hq.png": 65240,
	"./notimeforwitches-hq.png": 61144,
	"./nubentes-hq.png": 45836,
	"./nubentes-ship-helenaetobias.png": 92092,
	"./numikins-char-sapinho.png": 24124,
	"./numikins-hq.png": 1760,
	"./oabismo-exp-francesca.png": 17704,
	"./oabismo-hq.png": 62444,
	"./oabismo-onom-dlindlon.png": 69255,
	"./oamoréreceita-hq.png": 95636,
	"./oataquedosvirus-hq.png": 76856,
	"./obliteringrage-hq.png": 4056,
	"./ocanavial-hq.png": 84552,
	"./oceifadordemonstros-hq.png": 63048,
	"./ochamadolqn-cenas-roland.png": 39740,
	"./ochamadolqn-golp-ochamadolqn.png": 75868,
	"./ochamadolqn-hq.png": 75184,
	"./octozine-hq.png": 69196,
	"./octozine-masc-lulaldo.png": 41644,
	"./odaiment-hq.png": 99720,
	"./odiariodeprata-hq.png": 28196,
	"./ogarotodosino-capa.png": 87728,
	"./ogarotodosino-hq.png": 38228,
	"./oladrãodemundos-hq.png": 78000,
	"./olagarotodoespaço-hq.png": 80764,
	"./omeninoquedesenhamonstros-hq.png": 4336,
	"./omestredosmundos-hq.png": 33532,
	"./omisteriodaquintanoite-hq.png": 57732,
	"./omnistreife-hq.png": 53268,
	"./omonstrodebaixodacama-exp-garoto.png": 2836,
	"./omonstrodebaixodacama-hq.png": 70908,
	"./omonstrodebaixodacama-masc-biscoitosalada.png": 13508,
	"./omonstrodebaixodacama-masc-drago.png": 15692,
	"./omonstrodebaixodacama-multi-guerreiroestelar.png": 82228,
	"./onda-cena-euqueromudar.png": 96448,
	"./onda-cena-surfe.png": 63140,
	"./onda-exp-marcussusto.png": 59516,
	"./onda-hq.png": 9244,
	"./onda-masc-ratinho.png": 10908,
	"./onda-multi-gotohell.png": 65416,
	"./onda-multi-pingpongedrama.png": 28440,
	"./onda-ono-ablubaub.png": 24388,
	"./oparaisodereticulas-hq.png": 49956,
	"./operdedor-hq.png": 55052,
	"./oquarto-hq.png": 29456,
	"./orca-char-sereioorca.png": 78312,
	"./orca-hq.png": 36332,
	"./orca-masc-orca.png": 54556,
	"./oretornodekurt-cenas-cartaodosuspng.png": 19976,
	"./oretornodekurt-char-kurt.png": 21760,
	"./oretornodekurt-exp-imt.png": 15800,
	"./oretornodekurt-exp-pqp.png": 44864,
	"./oretornodekurt-exp-tedio.png": 54160,
	"./oretornodekurt-hq.png": 20744,
	"./oretornodekurt-shipp-kurtekim.png": 80792,
	"./oretratoinacabadodemadamebardin-hq.png": 98356,
	"./oretratoinacabadodemadamebardin-ship-francinecharlotte.png": 73276,
	"./oscontosdeazgra-hq.png": 51128,
	"./oscontosdosamuraidamontanha-hq.png": 20423,
	"./osetfinal-exp-quebreeega.png": 49148,
	"./osetfinal-hq.png": 5344,
	"./osguardioesdetupa-hq.png": 85896,
	"./osmarcados-hq.png": 19340,
	"./osoldadoeaninpha-hq.png": 21748,
	"./osomdavida-cenas-musica.png": 2456,
	"./osomdavida-hq.png": 40512,
	"./osomdavida-ship-elisaedanielpng.png": 30212,
	"./osorrisooculto-hq.png": 708,
	"./ospalhaços-hq.png": 56324,
	"./osraiosdelostsun-hq.png": 79560,
	"./ossonsqueouço-exp-vânia.png": 70076,
	"./ossonsqueouço-hq.png": 12792,
	"./ossonsqueouço-masc-kaizen.png": 49792,
	"./ostrabalhosdeelephteriah-hq.png": 25768,
	"./oszoeirosgold-hq.png": 97724,
	"./oultimofliperama-hq.png": 18700,
	"./ovazio-hq.png": 23676,
	"./overwift-capa.png": 71592,
	"./overwift-hq.png": 92084,
	"./overwift-masc-opereta.png": 24400,
	"./ovoluntario-capa.png": 38340,
	"./ovoluntario-cena-voosh.png": 70308,
	"./ovoluntario-hq.png": 48036,
	"./oxente-hq.png": 80996,
	"./oxente-lugar-nordeste.png": 34284,
	"./pansy-cenas-love.png": 91021,
	"./pansy-hq.png": 40360,
	"./pansy-lugar-muralha.png": 38764,
	"./pansy-shipp-pintortenente.png": 17172,
	"./paradigma-hq.png": 73988,
	"./paradisecity-hq.png": 40468,
	"./paranormalpanic-cena-busquemconehcimento.png": 64816,
	"./paranormalpanic-hq.png": 82288,
	"./paraterracomamor-hq.png": 66316,
	"./paulorangers-capa.png": 96928,
	"./paulorangers-hq.png": 86276,
	"./paveopacume-hq.png": 20352,
	"./penitente-hq.png": 62092,
	"./perdadecontrole-cena-parceiros.png": 4584,
	"./perdadecontrole-hq.png": 34540,
	"./perdadecontrole-shipp-erikamy.png": 91552,
	"./perfectblack-hq.png": 81036,
	"./perfectblack-onom-bololo.png": 68932,
	"./perfectcheese-hq.png": 71320,
	"./perfectcheese-masc-cheese.png": 7853,
	"./perolasperdidas-hq.png": 98336,
	"./persefone-exp-pip.png": 58368,
	"./persefone-hq.png": 8916,
	"./persefone-lugar-novolar.png": 7132,
	"./pescaria-hq.png": 98300,
	"./pingpongdrama-cena-motivaçao.png": 14187,
	"./pingpongdrama-char-paulopadilha.png": 68100,
	"./pingpongdrama-hq.png": 33613,
	"./pingponk-hq.png": 70300,
	"./pirates-exp-marina.png": 70044,
	"./pirates-hq.png": 58448,
	"./pirates-lugar-mcronalds.png": 83200,
	"./pitakoxpitako-char-fábulo.png": 62396,
	"./pitakoxpitako-hq.png": 27580,
	"./pitakoxpitako-multi-samuraialface.png": 68124,
	"./planetasagrado-hq.png": 28588,
	"./play-hq.png": 80744,
	"./pongocomics-hq.png": 22636,
	"./potentia-hq.png": 12132,
	"./potentiaorigin-exp-nojin.png": 59028,
	"./potentiaorigin-hq.png": 53828,
	"./primos-hq.png": 69103,
	"./princesadeareia-hq.png": 88304,
	"./projetomandibula-hq.png": 59560,
	"./ptca247-hq.png": 98640,
	"./purpose-hq.png": 81240,
	"./purpura-capa.png": 81504,
	"./purpura-hq.png": 27700,
	"./pérolasarcanas-hq.png": 328,
	"./pérolasarcanas-multi-apollo.png": 18604,
	"./quack-exp-pato.png": 91788,
	"./quack-golp-socomaguiladecuecassujas.png": 51648,
	"./quack-hq.png": 68836,
	"./quack-masc-colombo.png": 5876,
	"./quack-onom-pum.png": 68440,
	"./quadrinhosemambição-hq.png": 12648,
	"./quebraqueixo-hq.png": 84708,
	"./quimera-hq.png": 65789,
	"./rabbitfriend-hq.png": 54812,
	"./radiogaga-hq.png": 36564,
	"./rainynight-hq.png": 91780,
	"./ramuradragon-hq.png": 64196,
	"./razor-capa.png": 47464,
	"./razor-cena-equipe.png": 20104,
	"./razor-hq.png": 91564,
	"./razor-multi-faith.png": 62536,
	"./rebirthofshadows-capa.png": 38400,
	"./rebirthofshadows-hq.png": 75408,
	"./rebirthofshadows-lugares-pirocaodacidade.png": 3280,
	"./reboot-hq.png": 46764,
	"./redghost-char-shiro.png": 28876,
	"./redghost-exp-choro.png": 85300,
	"./redghost-hq.png": 74720,
	"./redlightning-hq.png": 23048,
	"./redoni-char-dragão.png": 24220,
	"./redoni-hq.png": 49344,
	"./redoni-masc-gatinhocego.png": 58684,
	"./redplague-hq.png": 89704,
	"./reidelata-exp-reidelata.png": 61744,
	"./reidelata-exp-ruivo.png": 48324,
	"./reidelata-golp-furacaodesocos.png": 75468,
	"./reidelata-golp-soconorteesuldoreidomundo.png": 30492,
	"./reidelata-golp-superfabulosoataquefurtivodaesther.png": 17636,
	"./reidelata-hq.png": 14316,
	"./reidelata-onom-plau.png": 35888,
	"./relichunters-hq.png": 73636,
	"./roar-hq.png": 76176,
	"./roland-cena-chuva.png": 21416,
	"./roland-golpe-hellsurfer.png": 24432,
	"./roland-hq.png": 15344,
	"./roland-masc-tala.png": 87216,
	"./rouboaotrem-hq.png": 32212,
	"./samael-capa.png": 45220,
	"./samael-hq.png": 70688,
	"./sanguedecria-hq.png": 17776,
	"./sanguedimensional-hq.png": 35796,
	"./sanguedoce-exp-uhum.png": 20628,
	"./sanguedoce-hq.png": 27296,
	"./sanguedoce-ship-alyasara.png": 14040,
	"./sanguequente-hq.png": 8192,
	"./sanguequente-lugar-tipicaesquinabr.png": 94976,
	"./seasonsofavallen-cena-floraguardiã.png": 43324,
	"./seasonsofavallen-golp-springsalegro.png": 56888,
	"./seasonsofavallen-hq.png": 68275,
	"./seca-cena-achuvacai.png": 16148,
	"./seca-hq.png": 78200,
	"./seeds-hq.png": 10020,
	"./senselife-artef-fuzilpng.png": 38236,
	"./senselife-cen-kalebcu.png": 76728,
	"./senselife-cena-acaçada.png": 49656,
	"./senselife-exp-kaleb.png": 51148,
	"./senselife-hq.png": 10072,
	"./sentiapormim-hq.png": 16500,
	"./serraverde-hq.png": 20688,
	"./setimosfilhos-exp-fone.png": 24164,
	"./setimosfilhos-hq.png": 78976,
	"./setimosfilhos-ono-pei.png": 75128,
	"./shitlove-hq.png": 71792,
	"./shooters-hq.png": 540,
	"./sideral-hq.png": 64840,
	"./sidyoaventureiro-hq.png": 86148,
	"./silvaomago-hq.png": 43528,
	"./silvermoon-hq.png": 81044,
	"./sindromededomino-hq.png": 24396,
	"./slave-capa.png": 93108,
	"./slave-char-kuro.png": 82628,
	"./slave-exp-conquistador.png": 75236,
	"./slave-hq.png": 90840,
	"./smellslikeshonenspirit-hq.png": 11016,
	"./soberania-hq.png": 69576,
	"./sobojugo-hq.png": 39104,
	"./sobosoldehelena-hq.png": 59596,
	"./sociedadesecretadosanduiche-hq.png": 43116,
	"./somaisumahistoriadeumabanda-hq.png": 65676,
	"./someonetocare-hq.png": 59464,
	"./sorcerygarnda-hq.png": 59208,
	"./soulmates-capa.png": 34408,
	"./soulmates-hq.png": 88652,
	"./soulmates-ship-monicaeheloise.png": 34432,
	"./southcurse-golpe-riodejaneiro.png": 72532,
	"./southcurse-hq.png": 25756,
	"./space-hq.png": 80516,
	"./spaceshit-hq.png": 64032,
	"./spiritman-hq.png": 17536,
	"./splittingimage-golp-cortenebula.png": 26352,
	"./splittingimage-hq.png": 13592,
	"./starmind-exp-inteligent.png": 33436,
	"./starmind-hq.png": 79380,
	"./starsquad-hq.png": 27908,
	"./starsquad-masc-robo.png": 1496,
	"./stellacintilante-hq.png": 52648,
	"./stellacintilante-multi-restaurantearmonpng.png": 2616,
	"./stellacintilante-multi-sabadodesucesso.png": 98192,
	"./straypigs-char-prático.png": 45128,
	"./straypigs-hq.png": 4888,
	"./straypigs-lugar-thecurral.png": 76516,
	"./superguerreiroomega-hq.png": 41336,
	"./superguerreiroomega-lugar-netuno1.png": 84983,
	"./superguerreiroomega-masc-kaiju.png": 29356,
	"./supernovasquad-hq.png": 30020,
	"./suriblade-cena-turblihao.png": 8277,
	"./suriblade-hq.png": 55400,
	"./suzysukeban-char-suzy.png": 35708,
	"./suzysukeban-exp-cigarro.png": 11888,
	"./suzysukeban-hq.png": 17732,
	"./suzysukeban-lugar-mercadinho.png": 43256,
	"./taico-capa.png": 87772,
	"./taico-hq.png": 98536,
	"./tala-hq.png": 22984,
	"./tamers-hq.png": 892,
	"./tattoo-hq.png": 80308,
	"./teatime-hq.png": 40896,
	"./tedomonstrinho-hq.png": 28708,
	"./tenebrous-hq.png": 79076,
	"./terex-hq.png": 19840,
	"./terex-masc-teresa.png": 18124,
	"./terraqueo-hq.png": 54828,
	"./thankyou-hq.png": 29628,
	"./thatspecialperson-char-florel.png": 16904,
	"./thatspecialperson-hq.png": 54200,
	"./thatspecialperson-shipp-springleseflorel.png": 36092,
	"./thebackrooms-hq.png": 2220,
	"./thebrideofthefox-hq.png": 55088,
	"./thecoop-hq.png": 28376,
	"./thecurseoftheequinox-hq.png": 85096,
	"./thegarden-hq.png": 840,
	"./thegoatwitch-char-valerie.png": 32540,
	"./thegoatwitch-hq.png": 86532,
	"./thegoatwitch-masc-duck.png": 56504,
	"./themoviemakers-hq.png": 96428,
	"./theo-hq.png": 94144,
	"./thepromisseofhappiness-hq.png": 49923,
	"./thesteelpolice-hq.png": 284,
	"./thetalesoflibertalia-exp-jhony.png": 82308,
	"./thetalesoflibertalia-hq.png": 53744,
	"./thunters-hq.png": 67356,
	"./tiamat-hq.png": 8093,
	"./tinodesanto-hq.png": 80408,
	"./tirinhasaleatorias-hq.png": 39988,
	"./tirinhasinominaveis-hq.png": 24940,
	"./tman-hq.png": 15420,
	"./tobiassalazar-char-tobias.png": 58404,
	"./tobiassalazar-hq.png": 42656,
	"./toolschallenge-artef-ferramenta.png": 99228,
	"./toolschallenge-golp-socao.png": 36928,
	"./toolschallenge-hq.png": 21400,
	"./toscomics-hq.png": 52484,
	"./toyfriend-hq.png": 85932,
	"./trakkar-hq.png": 38264,
	"./trapingame-char-moça.png": 7464,
	"./trapingame-exp-moça.png": 68684,
	"./trapingame-hq.png": 65760,
	"./trinityforce-hq.png": 50373,
	"./tropikalia-cenas-treinamento.png": 5428,
	"./tropikalia-cenas-zambi.png": 5020,
	"./tropikalia-char-mestrebesouro.png": 5884,
	"./tropikalia-char-zambi.png": 68340,
	"./tropikalia-golp-bicudapng.png": 73176,
	"./tropikalia-hq.png": 36004,
	"./tropikalia-masc-abaé.png": 70500,
	"./troublemakers-artef-aureola.png": 38428,
	"./troublemakers-capa.png": 18392,
	"./troublemakers-cenas-lucifer.png": 73784,
	"./troublemakers-cenas-norichegando.png": 65255,
	"./troublemakers-char-nori.png": 64208,
	"./troublemakers-char-noriedandara.png": 7004,
	"./troublemakers-exp-digubanori.png": 68011,
	"./troublemakers-exp-wasabii.png": 30647,
	"./troublemakers-golp-hellgrab.png": 13828,
	"./troublemakers-golp-hitsugicut.png": 52367,
	"./troublemakers-golp-hitsugihellgrab.png": 64228,
	"./troublemakers-golp-hitsujibeam.png": 72232,
	"./troublemakers-golp-mandatumprimitivum.png": 96792,
	"./troublemakers-golp-manxloaghtan.png": 87223,
	"./troublemakers-golp-troblebreakdance.png": 1956,
	"./troublemakers-golp-troublecombo.png": 11408,
	"./troublemakers-golp-troublepunch.png": 20328,
	"./troublemakers-golpes-combo.png": 64653,
	"./troublemakers-golpes-troublepunch.png": 89156,
	"./troublemakers-hq.png": 20855,
	"./troublemakers-masc-gato.png": 85308,
	"./troublemakers-masc-yobuta.png": 31376,
	"./tryagain-hq.png": 8304,
	"./tudoaotempo-hq.png": 45328,
	"./tudoounada-hq.png": 58840,
	"./tudoounada-onom-plau.png": 5924,
	"./turquoise-hq.png": 51200,
	"./twinheartzodiac-capa.png": 92308,
	"./twinheartzodiac-hq.png": 94004,
	"./twinheartzodiac-lugar-formigueiro.png": 73400,
	"./umahistoriadeguerra-hq.png": 4676,
	"./umapeça-hq.png": 62548,
	"./umbra-cena-naoeraele.png": 2528,
	"./umbra-char-luna.png": 84480,
	"./umbra-hq.png": 29388,
	"./umdiaruim-hq.png": 37828,
	"./umprincipenadaencantado-char-conselheiroreal.png": 64372,
	"./umprincipenadaencantado-hq.png": 67636,
	"./umprincipenadaencantado-shipp-princeealdeao.png": 98712,
	"./umsabadoqualquer-hq.png": 2981,
	"./underthestars-hq.png": 7576,
	"./universidadedosmortos-hq.png": 29160,
	"./unluckycrow-artef-ovo.png": 72788,
	"./unluckycrow-cena-vocedestruiuomeuovo.png": 51324,
	"./unluckycrow-exp-cientista.png": 64040,
	"./unluckycrow-hq.png": 88964,
	"./unluckycrow-multi-nativopower.png": 34608,
	"./unluckycrow-multi-troublemakerspng.png": 36676,
	"./vaderetro-cenas-correndoatrasdobusaoipng.png": 88756,
	"./vaderetro-cenas-vaderetro.png": 52832,
	"./vaderetro-char-waldisneypng.png": 76932,
	"./vaderetro-exp-wallace.png": 30152,
	"./vaderetro-hq.png": 51116,
	"./vaderetro-lugar-pontofeiradesantana.png": 92228,
	"./valecongelado-hq.png": 47452,
	"./veronikaeosapo-hq.png": 252,
	"./vidalongaaomarinheiro-hq.png": 65591,
	"./vidalongaomarinheiro-cena-mardecoisasparaesquecer.png": 42756,
	"./vidasimperfeitas-cena-beijocao.png": 95640,
	"./vidasimperfeitas-hq.png": 78872,
	"./vidasuperdistorcida-hq.png": 44456,
	"./vingadores-hq.png": 94672,
	"./violetaespecialdehalloween-hq.png": 56516,
	"./virtual-hq.png": 36104,
	"./vivendodedesenho-char-alberto.png": 44640,
	"./vivendodedesenho-hq.png": 57752,
	"./vivendodedesenho-multi-velhopapelao.png": 21432,
	"./wanderwonder-hq.png": 79824,
	"./wannabealegend-hq.png": 59772,
	"./warriorsouls-hq.png": 17568,
	"./wecanhelp-hq.png": 15380,
	"./westranger-hq.png": 55612,
	"./willowitch-cena-ocaminhocerto.png": 32052,
	"./willowitch-char-lancebauer.png": 76180,
	"./willowitch-exp-desespero.png": 7404,
	"./willowitch-golp-bigmaxpumpkin.png": 33956,
	"./willowitch-hq.png": 94696,
	"./willowitch-lugar-casinhadabruxa.png": 19248,
	"./witchingel-capa.png": 92004,
	"./witchingel-hq.png": 56664,
	"./wodamigosecreto-hq.png": 55364,
	"./xama-hq.png": 5152,
	"./xeretive-artef.png": 68048,
	"./xeretive-capa.png": 99452,
	"./xeretive-exp-ivy.png": 98904,
	"./xeretive-hq.png": 92104,
	"./xeretive-multi-reidelatasenselifepinpong48km.png": 98251,
	"./zanecia-hq.png": 83967,
	"./zeroday-hq.png": 69596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40916;